import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonToolbar, MenuItem } from "components/bootstrap";
import { IfPermitted, IconButton, LinkContainer } from "components/common";
import { MoreActions } from "components/common/EntityDataTable";
import Routes from "routing/Routes";
import recentMessagesTimeRange from "util/TimeRangeHelper";
import ForwarderInputStateControl from "./ForwarderInputStateControl";
import ForwarderRoutes from "../Routes";
const ForwarderInputsRowActions = ({ input }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const realInputId = input.input_id;
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarderinputs:changestate" }, /* @__PURE__ */ React.createElement(ForwarderInputStateControl, { input })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["searches:relative"] }, /* @__PURE__ */ React.createElement(
    LinkContainer,
    {
      key: `received-messages-${realInputId}`,
      to: Routes.search(`gl2_source_input:${realInputId}`, recentMessagesTimeRange())
    },
    /* @__PURE__ */ React.createElement(IconButton, { name: "search", title: t("inputs_actions.received_messages"), bsStyle: "default", size: "xsmall" })
  )), /* @__PURE__ */ React.createElement(MoreActions, null, /* @__PURE__ */ React.createElement(MenuItem, { href: ForwarderRoutes.PROFILE.details(input.input_profile_id) }, t("inputs_actions.view_input_profile"))));
};
export default ForwarderInputsRowActions;
